// src/pages/DuplicatesPage.jsx
import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import styles from './DuplicatesPage.module.css';

const TABS = [
  { key: 'routes',    label: 'Маршруты' },
  { key: 'receipts',  label: 'Квитанции' }
];

const DuplicatesPage = () => {
  const [activeTab, setActiveTab] = useState('routes');
  const [groups,    setGroups]    = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState(null);
  const [marked,    setMarked]    = useState(new Set());

  const fetchData = async (tab) => {
    setLoading(true);
    setError(null);
    setMarked(new Set());
    try {
      const res = await api.get(`/routes/duplicates/${tab}`);
      setGroups(res.duplicates || []);
    } catch (e) {
      setError(e.message || 'Ошибка при загрузке');
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  const toggleMark = (id) => {
    setMarked(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleGroupMarkAll = (items) => {
    setMarked(prev => {
      const next = new Set(prev);
      const allMarked = items.every(item => next.has(item.id));
      items.forEach(item => allMarked ? next.delete(item.id) : next.add(item.id));
      return next;
    });
  };

  const toggleAll = () => {
    setMarked(prev => {
      const next = new Set(prev);
      const allIds = groups.flatMap(g => g.items.map(i => i.id));
      const allMarked = allIds.every(id => next.has(id));
      allIds.forEach(id => allMarked ? next.delete(id) : next.add(id));
      return next;
    });
  };

  // batch-delete для квитанций
  const handleBulkDelete = async () => {
    if (marked.size === 0) return;
    if (!window.confirm('Удалить все отмеченные?')) return;

    try {
      const ids = Array.from(marked);
      await api.post('/receipts/removecascade', { receiptIds: ids });

      setGroups(groups
        .map(g => ({ ...g, items: g.items.filter(item => !marked.has(item.id)) }))
        .filter(g => g.items.length)
      );
      setMarked(new Set());
    } catch {
      alert('Ошибка при удалении отмеченных квитанций');
    }
  };

  // одиночное удаление маршрута
  const handleDeleteRoute = async (routeId) => {
    if (!window.confirm('Удалить этот маршрут?')) return;
    try {
      await api.delete(`/routes/${routeId}/removecascade`);
      setGroups(groups
        .map(g => ({ ...g, items: g.items.filter(i => i.id !== routeId) }))
        .filter(g => g.items.length)
      );
    } catch {
      alert('Ошибка при удалении маршрута');
    }
  };

  const handleMerge = async (key) => {
    if (!window.confirm('Объединить группу?')) return;
    try {
      await api.post('/duplicates/merge', { type: activeTab, key });
      setGroups(groups.filter(g => g[activeTab === 'receipts' ? 'receipt_number' : 'route_number'] !== key));
    } catch {
      alert('Ошибка при объединении');
    }
  };

  const allItemIds = groups.flatMap(g => g.items.map(i => i.id));
  const allMarked = allItemIds.length > 0 && allItemIds.every(id => marked.has(id));

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Дубликаты</h1>

      <div className={styles.tabs}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`${styles.tab} ${activeTab === tab.key ? styles.activeTab : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {loading && <div className={styles.loader}>Загрузка...</div>}
      {error   && <div className={styles.error}>{error}</div>}

      {!loading && !error && (
        groups.length === 0
          ? <p className={styles.noDuplicates}>Дубликатов не найдено</p>
          : (
            <>
              {/* Глобальные действия только для квитанций */}
{activeTab === 'receipts' && (
  <div className={styles.globalActions}>
    <button
      className={styles.selectAllBtn}
      onClick={() => {
        setMarked(prev => {
          const next = new Set(prev);
          // Пробегаем по всем группам и всем их items
          groups.forEach(g =>
            g.items.forEach(item => {
              // считаем общее число сканов
              const scanned = (Array.isArray(item.products) ? item.products : [])
                .reduce((sum, p) => sum + (Array.isArray(p.marks) ? p.marks.length : 0), 0);
              // условие: не привязана, открыта, сканов = 0
              if (
                !item.routeList// &&
                //item.status.trim().toLowerCase() === 'открыта' &&
                //scanned === 0
              ) {
                next.add(item.id);
              }
            })
          );
          return next;
        });
      }}
    >
      Отметить все (не привязанные, открытые, 0 сканов)
    </button>
    <button
      className={styles.bulkDeleteBtn}
      disabled={marked.size === 0}
      onClick={handleBulkDelete}
    >
      Удалить отмеченные ({marked.size})
    </button>
  </div>
)}

              {groups.map(group => {
                const keyField = activeTab === 'receipts' ? 'receipt_number' : 'route_number';
                const groupKey = group[keyField];
                const groupItems = group.items;

                return (
                  <div key={groupKey} className={styles.group}>
                    <div className={styles.header}>
                      <h2 className={styles.groupTitle}>{groupKey}</h2>
                      {activeTab === 'receipts' && (
                        <button
                          className={styles.selectAllBtn}
                          onClick={() => toggleGroupMarkAll(groupItems)}
                        >
                          {groupItems.every(i => marked.has(i.id)) ? 'Снять отметку' : 'Отметить все'}
                        </button>
                      )}
                      <button
                        className={styles.mergeBtn}
                        onClick={() => handleMerge(groupKey)}
                      >
                        Объединить все
                      </button>
                    </div>

                    <ul className={styles.list}>
                      {groupItems.map(item => {
                        // Квитанции этой группы
                        const receiptsArr = Array.isArray(item.receipts) ? item.receipts : [];
                        // Сколько закрытых
                        const closedCount = receiptsArr.filter(r =>
                          typeof r.status === 'string' &&
                          r.status.trim().toLowerCase() === 'закрыта'
                        ).length;

                        // Продукты и маркировки
                        const productsArr = Array.isArray(item.products) ? item.products : [];
                        const totalScanned = productsArr.reduce(
                          (sum, p) => sum + (Array.isArray(p.marks) ? p.marks.length : 0),
                          0
                        );
                        const totalQty = productsArr.reduce(
                          (sum, p) => sum + (p.actual_quantity || 0),
                          0
                        );

                        return (
                          <li key={item.id} className={styles.item}>
                            {activeTab === 'receipts' ? (
                              <>
                                <label className={styles.markLabel}>
                                  <input
                                    type="checkbox"
                                    checked={marked.has(item.id)}
                                    onChange={() => toggleMark(item.id)}
                                  />
                                  <span className={styles.markText}>Отметить</span>
                                </label>
<div className={styles.info}>
  <span>
    <strong>ID:</strong>{' '}
    <a
      href={`/courier/receipts/${item.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    >
      {item.id}
    </a>
  </span>
  <span><strong>Статус:</strong> {item.status}</span>
  <span><strong>Закрыто квит.:</strong> {closedCount}/{receiptsArr.length}</span>
  <span><strong>Сканировано марок:</strong> {totalScanned}/{totalQty}</span>

  {/* Вот этот новый блок: */}
  <span>
    <strong>Маршрут:</strong>{' '}
    {item.routeList
      ? `${item.routeList.route_number} (${item.routeList.route_date})`
      : 'Не привязана'}
  </span>
</div>
                                <ul className={styles.productsList}>
                                  {productsArr.map((product, idx) => {
                                    const scanned = Array.isArray(product.marks) ? product.marks.length : 0;
                                    return (
                                      <li key={idx}>
                                        {product.product_name} x{product.actual_quantity} — Сканов: {scanned}/{product.actual_quantity}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </>
                            ) : (
                              <>
                                <div className={styles.info}>
                                  <span>
                                    <strong>ID маршрута:</strong>{' '}
                                    <a
                                      href={`/courier/routes/${item.id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className={styles.link}
                                    >
                                      {item.id}
                                    </a>
                                  </span>
                                  <span><strong>Кв-ции:</strong> {receiptsArr.map(r => r.id).join(', ')}</span>
                                  <span><strong>Закрыто квит.:</strong> {closedCount}/{receiptsArr.length}</span>
                                </div>
                                <button
                                  className={styles.deleteRouteBtn}
                                  onClick={() => handleDeleteRoute(item.id)}
                                >
                                  Удалить
                                </button>
                              </>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </>
          )
      )}
    </div>
  );
};

export default DuplicatesPage;
